"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const GlobalData_1 = require("./GlobalData");
const DependencyInjector_1 = require("./DependencyInjector");
const component = require("./ComponentRegister");
class FetchProxy {
    constructor(input, init = {}) {
        this.reqAuth = false;
        this.input = input;
        this.init = init;
    }
    auth(force = true) {
        if (GlobalData_1.currentUser == undefined && force) {
            throw new Error("no login user");
        }
        if (GlobalData_1.currentUser == undefined && !force) {
            return this;
        }
        if (this.init.headers === undefined) {
            this.init.headers = {
                'Authorization': GlobalData_1.currentUser.token
            };
        }
        else {
            this.init.headers['Authorization'] = GlobalData_1.currentUser.token;
        }
        this.reqAuth = true;
        return this;
    }
    async fetch() {
        const res = await (0, DependencyInjector_1.Fetch)(this.input, this.init);
        this.resValidate(res);
        return res;
    }
    resValidate(res) {
        if (res.ok) {
            return;
        }
        if (res.status === 401 && this.reqAuth) {
            component.get('Authorization').userAuthLost();
        }
        throw new Error(`${res.status}`);
    }
}
exports.default = FetchProxy;
//# sourceMappingURL=FetchProxy.js.map